const experimentalUploadURL = localStorage.getItem('experimentalUploadUrl') || null

export const config = {
  CHUNKS_UPLOADING_HOST: experimentalUploadURL || process.env.REACT_APP_CHUNKS_UPLOADING_HOST || '',
  VIDEO_UPLOADING_HOST: process.env.REACT_APP_VIDEO_UPLOADING_WEB_HOST || '',
}
